import z from "zod";
import { SUPPORTED_CONNECTOR_PROTOCOL_VERSION } from "./protocol.js";
export const ConnectorAtlassianOAuthCredentialSchema = z.object({
    kind: z.literal("atlassian-oauth"),
    cloudId: z.string().min(1),
    siteUrl: z.string().url(),
    accessToken: z.string().min(1),
    refreshToken: z.string().min(1),
    accessTokenExpiresAt: z.string().datetime(),
    scopes: z.array(z.string()),
});
export const ConnectorGitHubAppCredentialSchema = z.object({
    kind: z.literal("github-app"),
    installationId: z.string().min(1),
    accountLogin: z.string().min(1),
    accountName: z.string().min(1),
    accountId: z.string().min(1),
    accountType: z.enum(["User", "Organization"]),
    repositorySelection: z.enum(["all", "selected"]),
});
export const ConnectorCredentialPayloadSchema = z.discriminatedUnion("kind", [
    ConnectorAtlassianOAuthCredentialSchema,
    ConnectorGitHubAppCredentialSchema,
]);
export const ConnectorCredentialActionSchema = z.enum(["store", "delete"]);
export const ConnectorTransportCredentialSchema = z.object({
    protocolVersion: z.literal(SUPPORTED_CONNECTOR_PROTOCOL_VERSION),
    kind: z.literal("credential"),
    requestId: z.string().uuid(),
    connectionRef: z.string().min(1),
    action: ConnectorCredentialActionSchema,
    payload: ConnectorCredentialPayloadSchema.optional(),
});
export const ConnectorCredentialAckStatusSchema = z.enum([
    "stored",
    "deleted",
    "error",
]);
export const ConnectorTransportCredentialAckSchema = z.object({
    protocolVersion: z.literal(SUPPORTED_CONNECTOR_PROTOCOL_VERSION),
    kind: z.literal("credentialAck"),
    requestId: z.string().uuid(),
    connectionRef: z.string().min(1),
    status: ConnectorCredentialAckStatusSchema,
    message: z.string().min(1).optional(),
});
//# sourceMappingURL=credential.schema.js.map